/**
 * Centralizes icon asset paths for the left navigation.
 * Using icon keys here avoids hardcoded icon paths in UI templates/components.
 */
import { LeftNavIconKey } from '../models/left-nav-item.model';

export const LEFT_NAV_ICON_PATHS: Record<LeftNavIconKey, string> = {
    automation: 'assets/left_nav_icons/automation.svg',
    dashboard: 'assets/left_nav_icons/dashboard.svg',
    documents: 'assets/left_nav_icons/documents.svg',
    integration: 'assets/left_nav_icons/integration.svg',
    process: 'assets/left_nav_icons/reconciliation.svg',
    settings: 'assets/left_nav_icons/settings.svg',
    'api-keys': 'assets/left_nav_icons/api-keys.svg',
    horizontal_lines_3: 'assets/left_nav_icons/horizontal_lines_3.svg',
};
